import { useContext } from 'react'
import { apiRoutes } from 'config/apiRoutes'
import { AreaTypeRes } from 'features/areaTypes/types/areaTypes.types'
import { useQuery } from 'libs/query'
import { useParams } from 'libs/router'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store/AuthContext'
import { queryKeys } from 'config/queryKeys'

export const useFetchAreaType = () => {
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const { auth } = useContext(AuthContext)

	const { data: boothType, isSuccess: isAreaTypeSuccess } = useQuery<AreaTypeRes>({
		queryKey: queryKeys.boothTypes.detail(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.areaType(params.id as string)),
		enabled: !!auth.accessToken
	})

	return {
		boothType,
		isAreaTypeSuccess
	}
}
